import { styled } from '@mui/material/styles';
import { TableSortLabel } from '@mui/material';

export const StyledTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
    "fontSize": '12px',
    "lineHeight": '18px',
    "borderRadius": '12px',
    "color": theme.palette.text.secondary,
    "padding": '2px 10px',
    '&.Mui-active': {
        color: theme.palette.text.secondary,
    },
}));
